export default __webpack_public_path__ + "static/photon_background-977f67020faf860a9d6442d05e6f2084.svg";